export default __webpack_public_path__ + "static/media/resware2.9502cbd0.PNG";